import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../providers/auth';
import { paths } from '../common/constants/Rutas';

export const PublicRoute = ({ children }) => {

    const { isAuthenticated } = useContext( AuthContext );

    return (!isAuthenticated)
        ? children
        : <Navigate to={paths.Consumos} replace />
}
